import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04dc69df"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "viewable grid mx-0 mb-3" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "col-8 text-small" }
const _hoisted_4 = {
  key: 0,
  class: "col-4 text-right text-small"
}

import { ref, withDefaults, onBeforeMount, watch, computed } from "vue";
import { get, useDateFormat } from "@vueuse/core";
import { DATE_TIME_FORMAT } from "@/clinic/typings/constants/booking";

type IEditableTexarea = {
  noteId: number;
  customerId: number;
  clinicId: number;
  content: string;
  created: string;
  disabled: boolean;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    noteId: null,
    customerId: null,
    clinicId: null,
    content: { default: "" },
    created: null,
    disabled: { type: Boolean, default: false }
  },
  emits: ["trash", "show"],
  setup(__props: any, { emit: emits }) {

const props = __props as { noteId: number, customerId: number, clinicId: number, content: string, created: string, disabled: boolean };



const noteVal = ref<string>("");
const initAttributes = () => {
  if (!noteVal.value) {
    noteVal.value = props.content;
  }
};
const noteValue = computed(() => get(noteVal).replace(/\n/g, "<br>"));
const onShow = () => emits("show", props.noteId, get(noteVal));
const onTrash = () => emits("trash", props.noteId);
onBeforeMount(() => {
  initAttributes();
});

// Watch for changes in props.comment and update commentVal
watch(
  () => props.content,
  newValue => {
    noteVal.value = newValue;
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "col-12 note-value",
      innerHTML: _unref(noteValue)
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", null, _toDisplayString(_unref(get)(_unref(useDateFormat)(__props.created, _unref(DATE_TIME_FORMAT)))), 1)
    ]),
    (!props.disabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("i", {
            class: "pi pi-pencil cursor-pointer mr-2",
            onClick: onShow
          }),
          _createElementVNode("i", {
            class: "pi pi-trash cursor-pointer",
            onClick: onTrash
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})